/** Shared Constructs */
import faviconBadge from './shared/favicon-badge.js';

/** Theme Constructs */
import convertAmp from './theme/convert-amp';
import fancybox from './theme/fancybox.js';
import menuFocusAria from './theme/menu-focus-aria';
import scrollTransition from './theme/scroll-transition';
import wpBlockGroupIsStyleCollapsible from './theme/wp-block-group-is-style-collapsible';
import selectChangeLocation from './theme/select-change-location';

/** Theme Atoms */
// import aMaxWidthIFrame from './theme/a-max-width-iframe';
import aMinWidthTable from './theme/a-min-width-table';

/** Theme Molecules */

/** Theme Organisms */

document.addEventListener('DOMContentLoaded', function() {

  /** Address HTML & Body no-js Class */
  (function () {

    /** Remove .no-js */
    // document.documentElement.classList.remove('no-js');
    // document.body.classList.remove('no-js');

    /** Replace .no-js with .js */
    document.documentElement.className = document.documentElement.className.replace('no-js', 'js');
    document.body.className = document.body.className.replace('no-js', 'js');
  })();

  /** Shared Constructs */
  faviconBadge();

  /** Theme Constructs */
  fancybox();
  menuFocusAria();
  scrollTransition();
  wpBlockGroupIsStyleCollapsible();
  selectChangeLocation();

  /** Theme Atoms */
  // aMaxWidthIFrame();
  aMinWidthTable();

  /** Theme Molecules */

  /** Theme Organisms */

  /**
   * Mobile Menu Focus Trapping
   *
   * @author Dylan James Wagner
   */
  (function () {
    let mobileMenu = document.querySelector('.mobile-menu');
    mobileMenu.addEventListener('focusout', event => {
      if (mobileMenu.matches(':not(:focus-within)')) {
        let mobileMenuToggle = mobileMenu.querySelector('.mobile-menu__toggle');
        if (event.target === mobileMenuToggle) {
          let lastLinks = mobileMenu.querySelectorAll(`
            .mobile-menu__list > .menu__item:last-child > a[href],
            .mobile-menu__list > .menu__item:last-child > .menu__children-toggle,
            .mobile-menu__list > .menu__item:last-child > .menu__children-toggle:checked ~ .menu__children > .menu__item:last-child > a[href]
          `);
          lastLinks[(lastLinks.length - 1)].focus(); // focus the deepest link
        }
        else {
          mobileMenuToggle.focus();
        }
      }
    });
  })();

  /** .is-style-arrow--widont */
  (function () {
    /**
     * Rejected ES7 proposal for RegExp.escape
     *
     * @link https://stackoverflow.com/a/63838890/2984139
     */
    if (!Object.prototype.hasOwnProperty.call(RegExp, 'escape')) {
      RegExp.escape = function(string) {
        // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Guide/Regular_Expressions#Escaping
        // https://github.com/benjamingr/RegExp.escape/issues/37
        return string.replace(/[.*+\-?^${}()|[\]\\]/g, '\\$&'); // $& means the whole matched string
      };
    }

    let isStyleArrows = document.querySelectorAll('.is-style-arrow a');
    isStyleArrows.forEach((element) => {
      let splitTextLast = element.textContent.split(' ').splice(-1).join(' ');
      // element.innerHTML = element.textContent.replace(new RegExp(splitTextLast + '$'), `<span class="widont">${splitTextLast}</span>`);
      element.innerHTML = element.textContent.replace(new RegExp(RegExp.escape(splitTextLast) + '$'), `<span class="widont">${splitTextLast}</span>`);
      element.closest('.is-style-arrow').classList.add('is-style-arrow--widont');
    });
  })();

  convertAmp();

});
